import { useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { useTranslation } from 'react-i18next';
import { Badge } from '../../../components/ui/badge';

/**
 * data: [{ year: '2020', allDeals: 12, leadInvestor: 5, secondInvestor: 7 }, ...]
 */
function InvestorDealsChart({ data = [] }) {
  const { t } = useTranslation();
  const [displayedData, setDisplayedData] = useState('allDeals');

  const dataKeyText = {
    allDeals: t('pageInvProf.graphBtn1'),        // "All deals"
    leadInvestor: t('pageInvProf.graphBtn2'),   // "Lead investor"
    secondInvestor: t('pageInvProf.graphBtn3'), // "Second investor"
  };

  if (!Array.isArray(data) || data.length === 0) {
    return <div />;
  }

  return (
    <div>
      <ResponsiveContainer width="100%" height={270}>
        <LineChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
          <XAxis dataKey="year" />
          <YAxis allowDecimals={false} />
          <Tooltip formatter={(value) => `${value} deals`} />
          <Legend />
          {displayedData === 'allDeals' && (
            <Line
              type="monotone"
              dataKey="allDeals"
              stroke="oklch(0.45 0.085 224.283)"
              strokeWidth={3}
              dot={{ r: 6 }}
              activeDot={{ r: 8 }}
              name={dataKeyText.allDeals}
              animationDuration={800}
            />
          )}
          {displayedData === 'leadInvestor' && (
            <Line
              type="monotone"
              dataKey="leadInvestor"
              stroke="oklch(0.268 0.007 34.298)"
              strokeWidth={3}
              dot={{ r: 6 }}
              activeDot={{ r: 8 }}
              name={dataKeyText.leadInvestor}
              animationDuration={800}
            />
          )}
          {displayedData === 'secondInvestor' && (
            <Line
              type="monotone"
              dataKey="secondInvestor"
              stroke="oklch(0.453 0.124 130.933)"
              strokeWidth={3}
              dot={{ r: 6 }}
              activeDot={{ r: 8 }}
              name={dataKeyText.secondInvestor}
              animationDuration={800}
            />
          )}
        </LineChart>
      </ResponsiveContainer>

      <div className="flex p-4 gap-2">
  <Badge
    text={t('pageInvProf.graphBtn1')}
    onClick={() => setDisplayedData('allDeals')}
    className={`cursor-pointer ${displayedData === 'allDeals'
      ? 'bg-cyan-800 text-white'
      : 'bg-cyan-800 text-white hover:bg-cyan-600 hover:text-white'}`}
  />
  <Badge
    text={t('pageInvProf.graphBtn2')}
    onClick={() => setDisplayedData('leadInvestor')}
    className={`cursor-pointer ${displayedData === 'leadInvestor'
      ? 'bg-stone-800 text-white'
      : 'bg-stone-800 text-white hover:bg-stone-600'}`}
  />
  <Badge
    text={t('pageInvProf.graphBtn3')}
    onClick={() => setDisplayedData('secondInvestor')}
    className={`cursor-pointer ${displayedData === 'secondInvestor'
      ? 'bg-lime-800 text-white'
      : 'bg-lime-800 text-white hover:bg-lime-600'}`}
  />
</div>
    </div>
  );
}

export default InvestorDealsChart;
